<template>
  <div v-if="schema.length" class="form-row">
    <div
      v-for="field in schema"
      :key="field.key"
      :class="['form-group', field.col || 'col-md-6']"
    >
      <label>
        <span v-if="field.required" class="required">*</span>
        {{ field.label }}:
      </label>

      <input
        v-if="field.type === 'number'"
        type="number"
        class="form-control"
        :value="value[field.key]"
        @input="update(field.key, $event.target.value)"
      />
      <textarea
        v-else-if="field.type === 'textarea'"
        class="form-control"
        rows="3"
        :value="value[field.key]"
        @input="update(field.key, $event.target.value)"
      />
      <select
        v-else-if="field.type === 'select'"
        class="form-control"
        :value="value[field.key]"
        @change="update(field.key, $event.target.value)"
      >
        <option value="">{{ $t("fieldSchema.selectOption") }}</option>
        <option v-for="opt in field.options" :key="opt" :value="opt">{{ opt }}</option>
      </select>
      <input
        v-else
        type="text"
        class="form-control"
        :value="value[field.key]"
        @input="update(field.key, $event.target.value)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "DynamicMetadataFields",
  props: {
    schema: { type: Array, default: () => [] },
    value: { type: Object, default: () => ({}) },
  },
  methods: {
    update(key, val) {
      this.$emit("input", { ...this.value, [key]: val });
    },
  },
};
</script>

<style scoped>
.required {
  color: red;
}
</style>
